import { useEffect, useRef } from 'react';
import type { DisplayFormData } from '../../standalone/types';
import { usePrimaryFill } from '../../hooks/usePrimaryFill';
import styles from './FormMessage.module.css';

interface FormMessageProps {
  form: DisplayFormData;
  isDisabled: boolean;
  isSubmitted: boolean;
  onOpenForm: (form: DisplayFormData) => void;
  primaryColor?: string;
  primaryHoverColor?: string;
  useGradient?: boolean;
}

export function FormMessage({ form, isDisabled, isSubmitted, onOpenForm, primaryColor, primaryHoverColor, useGradient = false }: FormMessageProps) {
  const hasAutoOpened = useRef(false);

  useEffect(() => {
    if (form.start_open && !isSubmitted && !hasAutoOpened.current) {
      hasAutoOpened.current = true;
      onOpenForm(form);
    }
  }, [form, isSubmitted, onOpenForm]);

  const disabled = isSubmitted || isDisabled;

  const { style: fillStyle, onMouseEnter, onMouseLeave } = usePrimaryFill(
    !disabled ? primaryColor : undefined,
    primaryHoverColor,
    useGradient,
  );

  return (
    <button
      type="button"
      className={`${styles.container} ${disabled ? styles.containerDisabled : styles.containerEnabled}`}
      disabled={disabled}
      onClick={() => onOpenForm(form)}
      style={fillStyle}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <span className={styles.title}>{form.title}</span>
      {form.description && (
        <span className={styles.description}>{form.description}</span>
      )}
    </button>
  );
}
